import { CustomElement, Component } from "../../core/CustomElement";
export interface CCCIconState {
  icon: string;
  size: string;
}

@Component("ccc-icon", {
  template: require("./template.html").default,
  observedAttributes: ["icon", "size"],
})
export class CCCIcon extends CustomElement {
  // eslint-disable-next-line
  state: CCCIconState = { icon: "", size: "" };
  iconDiv: HTMLElement = null;

  // eslint-disable-next-line
  attributeChangedCallback(attr: string, oldValue: any, newValue: any) {
    if (attr == "size") {
      // Do something
      if (oldValue && oldValue !== "") {
        this.removeOldClass(this.buildSizeClass(oldValue));
      }
      this.setKeyState("size", newValue);
    }

    if (attr == "icon") {
      // Do something
      if (oldValue && oldValue !== "") {
        this.removeOldClass(this.buildIconClass(oldValue));
      }
      this.setKeyState("icon", newValue);
    }
  }

  // eslint-disable-next-line
  buildIconClass(text: string) {
    return "oj-ux-ico-" + text;
  }

  // eslint-disable-next-line
  buildSizeClass(text: string) {
    return "oj-ux-icon-size-" + text + "x";
  }

  // eslint-disable-next-line
  removeOldClass(oldVal: string) {
    this.iconDiv = this.shadowDom.querySelector(".oj-ux-icon");
    this.iconDiv.classList.remove("oj-ux-ico-" + oldVal);
  }

  // eslint-disable-next-line
  watchIcon() {
    if (this.state.icon !== "") {
      this.iconDiv = this.shadowDom.querySelector(".oj-ux-icon");
      this.iconDiv.classList.add(this.buildIconClass(this.state.icon));
    }
  }

  // eslint-disable-next-line
  watchSize() {
    if (this.state.icon !== "") {
      this.iconDiv.classList.add(this.buildSizeClass(this.state.size));
    }
  }
}
